/**
 * Общие форматтеры и константы подраздела «Инфраструктурные проекты»
 * (US-05.1): деньги в млн/млрд тенге (FR-13, форматирование «как на
 * дашборде»), палитра серий чартов и риск-уровни освоения (FR-8.2).
 */
import type { InfrastructureProject } from '../../../types/projects';

export const fmt = (v: number): string =>
  Intl.NumberFormat('ru-RU').format(v);

export const fmt1 = (v: number): string =>
  Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(v);

/**
 * Денежная величина в млн тенге → значение + признак «млрд»:
 * 18 600 → «18,6» млрд ₸, 640 → «640» млн ₸. Подпись единицы —
 * projects.units.mlnTg / mlrdTg (i18n на стороне компонента).
 */
export const moneyMln = (vMln: number): { value: string; mlrd: boolean } =>
  Math.abs(vMln) >= 1000
    ? { value: fmt1(vMln / 1000), mlrd: true }
    : { value: fmt1(vMln), mlrd: false };

/** Палитра серий донатов/легенд — как в чартах «Аналитики»
 * (константы серий в компонентах — существующий паттерн раздела). */
export const CHART_COLORS = [
  '#2C9C42', // brand-600
  '#4A63E7', // chart-indigo
  '#1F2A24', // text
  '#D89B1F', // status-warning
  '#E87BA4',
];

/**
 * Годовое освоение проекта, % (риск-виджет и карточка): без годового
 * плана проект считается освоенным (завершён в предыдущем периоде).
 */
export const yearDevelopmentPct = (p: InfrastructureProject): number => {
  if (p.planYearMln == null || p.planYearMln === 0) return 100;
  return ((p.factYearMln ?? 0) / p.planYearMln) * 100;
};

export type RiskLevel = 'ok' | 'warning' | 'serious' | 'critical';

/**
 * Уровень риска по % годового освоения (FR-8.2). Границы 60/40/20 —
 * условные, по мокапу; точные значения — ТРЕБУЕТ УТОЧНЕНИЯ (владелец:
 * разработка / PO).
 */
export const riskLevel = (pct: number): RiskLevel => {
  if (pct >= 60) return 'ok';
  if (pct >= 40) return 'warning';
  if (pct >= 20) return 'serious';
  return 'critical';
};
